import Meeting from "../../assets/images/sidebar/meeting.svg";
import Work from "../../assets/images/sidebar/work.svg";
import Office from "../../assets/images/sidebar/office.svg";
import TimeOff from "../../assets/images/sidebar/timeoff.svg";
import variableStyles from "../../theme/variable-styles";

export enum Roles {
  Member = "Member",
  Admin = "Admin",
  SuperAdmin = "SuperAdmin"
}

export enum FeatureModel {
  HR = "HR",
  Department = "Department",
  MeetingRoom = "MeetingRoom",
  MeetingRoomSchedule = "MeetingRoomSchedule",
  TimeOff = "TimeOff",
  TimeOffType = "TimeOffType",
  Rules = "Rules",
  Document = "Document",
  DocumentType = "DocumentType",
  Payroll = "Payroll",
  OpenAi = "OpenAi"
}

export enum TimeOffPermissionModel {
  View = "View",
  ManagerTimeOff = "ManagerTimeOff",
  AdminTimeOff = "AdminTimeOff",
  ManagerUpdateStatus = "ManagerUpdateStatus",
  AdminUpdateStatus = "AdminUpdateStatus",
  TeamLeaderUpdateStatus = "TeamLeaderUpdateStatus",
  Create = "Create",
  Delete = "Delete",
  AdminDelete = "AdminDelete"
}

export enum TimeOffTypePermissionModel {
  View = "View",
  Create = "Create",
  Update = "Update",
  Delete = "Delete",
  MailCC = "UpdateMailCC"
}

export enum DepartMentPermissionModel {
  View = "View",
  ViewAll = "ViewAll",
  Create = "Create",
  Update = "Update",
  Delete = "Delete"
}

export enum MeetingRoomPermissionModel {
  View = "View",
  Create = "Create",
  Update = "Update",
  Delete = "Delete"
}

export enum MeetingRoomSchedulePermissionModel {
  View = "View",
  Create = "Create",
  Update = "Update",
  UserUpdateStatus = "UserUpdateStatus",
  AdminUpdateStatus = "AdminUpdateStatus",
  Delete = "Delete"
}

export enum HRPermissionModel {
  ViewListUser = "ViewListUser",
  RegisterUser = "RegisterUser",
  EditUser = "EditUser",
  DeleteUser = "DeleteUser",
  ViewUserRegisterTimeOff = "ViewUserRegisterTimeOff",
  GetMaillCC = "GetMaillCC",
  UpdateMailCC = "UpdateMailCC",
  UpdateTotalTimeOffForUser = "UpdateTotalTimeOffForUser"
}

export enum OpenAiPermissionModel {
  View = "View",
  Edit = "Edit",
  TaskAnalytics = "TaskAnalytics"
}

export enum RulesPermissionModel {
  View = "View",
  Update = "Update"
}

export enum DocumentPermissionModel {
  View = "View",
  AdminView = "AdminView",
  Create = "Create",
  Update = "Update",
  Delete = "Delete"
}

export enum DocumentTypePermissionModel {
  View = "View",
  Create = "Create",
  Update = "Update",
  Delete = "Delete"
}

export enum PayRollPermissionModel {
  View = "View",
  Create = "Create"
}

export enum ObjectStatus {
  Active = "active",
  DeActive = "deactive"
}
export enum OrderDirection {
  DESC = "DESC",
  ASC = "ASC"
}
export enum EImageType {
  png = ".png",
  jpeg = ".jpeg",
  jpg = ".jpg"
}

export enum ECurrencyCode {
  VND = "VND",
  USD = "USD",
  EUR = "EUR"
}

export enum ELanguage {
  Vie = "vi-VN",
  Eng = "en-US"
}

export enum EFlow {
  Inflow = 0,
  Outflow = 1
}

export enum EModeModal {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  NOTHING = "NOTHING"
}

export enum ExchangeRateType {
  USDtoVND = "USD/VND",
  EURtoVND = "EUR/VND",
  EURtoUSD = "EUR/USD"
}

export enum TypeLink {
  internal = "internal",
  external = "external"
}

export enum UserAction {
  EditInformation = "User.EditInformation",
  ChangePassword = "User.ChangePassword",
  ChangeManage = "User.EditDirectManager",
  ChangeAdministration = "User.AdminPermissions",
  UpdateTotalTimeOffForUser = "User.UpdateAnnuaLeave"
}

// export enum UserAction {
//   EditInformation = "Chỉnh sửa thông tin cá nhân",
//   ChangePassword = "Thay đổi mật khẩu",
//   ChangeManage = "Chỉnh sửa người quản lý trực tiếp",
//   ChangeAdministration = "Phân quyền quản trị",
//   UpdateTotalTimeOffForUser = "Cập nhật phép năm"
// }

export enum TagType {
  User = 0,
  Department = 1,
  Conversation = 2
}

export enum EStageType {
  Step = 0,
  Cancel = 1,
  Complete = 2
}

export enum ETaskStatus {
  Inprogress = 0,
  Cancel = 1,
  Complete = 2,
  Failed = 3
}

export enum EWorkflowProcess {
  Continue = 0,
  First = 1,
  Other = 2,
  TaskAssigneeDecides = 3,
  SelectStep = 4,
  Randomly_Select_One_Person_To_Take_On_The_Task = 5
}

export enum EFireBaseType {
  AssignTask = 0,
  UpdateTask = 1,
  UpdateBoard = 2,
  RegisterTimeOff = 3,
  AprroveTimeOff = 4,
  NotAprroveTimeOff = 5,
  RegisterMeetingRoomSchedule = 6,
  AwaitCancelMeetingRoomSchedule = 7,
  AprroveMeetingRoomSchedule = 8,
  CancelMeetingRoomSchedule = 9,
  ReleasedDocument = 10,
  CommentTask = 11,
  ReplyCommentTask = 12,
  DeadlineTask = 13
}

export enum ETimeOffStatus {
  Pending,
  ManagerApprove,
  CEOApprove,
  NotApprove,
  TeamLeaderApprove
}
export enum EDayOffSession {
  Morning,
  Afternoon,
  AllDay
}

export enum ETimeOffOperation {
  NotOperation,
  Plus,
  Minus
}

export enum ETimeOffType {
  Leave_of_absence_with_permission_for_less_than_3days,
  Leave_of_absence_with_permission_for_more_than_3days,
  Leave_of_absence_without_permission_for_less_than_3days,
  Leave_of_absence_without_permission_for_more_than_3days
}

export const taskCardStatusColor = (
  status: ETaskStatus
): { color: string; bgcolor: string } => {
  switch (status) {
    case ETaskStatus.Inprogress:
      return { color: variableStyles.MainColor, bgcolor: "#EAF4FE" };
    case ETaskStatus.Cancel:
      return { color: "#F2A533", bgcolor: "#FEF6EB" };
    case ETaskStatus.Complete:
      return { color: "#54BD95", bgcolor: "#EEF8F4" };
    case ETaskStatus.Failed:
      return { color: "#ED3E47", bgcolor: "#FDECED" };
    default:
      return { color: "#000000", bgcolor: "000000" };
  }
};

export const taskStatusTitle = (status: ETaskStatus): string => {
  switch (status) {
    case ETaskStatus.Inprogress:
      return "Management.InProgress";
    case ETaskStatus.Cancel:
      return "Management.Cancel";
    case ETaskStatus.Complete:
      return "Management.Done";
    case ETaskStatus.Failed:
      return "Management.Failed";
    default:
      return "MeetingStatus.Unknown";
  }
};

export enum EFileType {
  jpg = ".jpg",
  jpeg = ".jpeg",
  png = ".png",
  gif = ".gif",
  mp4 = ".mp4",
  mov = ".mov",
  avi = ".avi",
  flv = ".flv",
  docx = ".docx",
  doc = ".doc",
  xlxs = ".xlsx",
  cvs = ".cvs",
  pdf = ".pdf",
  pptx = ".pptx",
  ppt = ".ppt"
}

export enum EFireBaseTypeEnum {
  AssignTask = 0,
  UpdateTask = 1,
  UpdateBoard = 2
}

export enum EMeetingRoomStatus {
  Pending = 0,
  Confirmed = 1,
  Cancel = 2,
  Completed = 3,
  WaitCancel = 4
}

export enum EMeetingRoomScheduleTypeEnum {
  Month,
  Week,
  Day
}

export const meetingRoomStatusColor = (
  status?: EMeetingRoomStatus | null
): { color: string; bgcolor: string } => {
  switch (status) {
    case EMeetingRoomStatus.WaitCancel:
      return { color: "#E7B036", bgcolor: "#FFF8E8" };
    case EMeetingRoomStatus.Confirmed:
      return { color: "#54BD95", bgcolor: "#EEF8F4" };
    case EMeetingRoomStatus.Cancel:
      return { color: "#ED3E47", bgcolor: "#FFEFF0" };
    case EMeetingRoomStatus.Pending:
      return { color: "#3091F3", bgcolor: "#EAF4FE" };
    default:
      return { color: "#AAAAB2", bgcolor: "#F0F0F0" };
  }
};

export const meetingRoomStatusTitle = (status?: EMeetingRoomStatus | null) => {
  switch (status) {
    case EMeetingRoomStatus.Pending:
      return "MeetingStatus.Pending";
    case EMeetingRoomStatus.Confirmed:
      return "MeetingStatus.Confirmed";
    case EMeetingRoomStatus.Cancel:
      return "MeetingStatus.Cancel";
    case EMeetingRoomStatus.WaitCancel:
      return "MeetingStatus.WaitCancel";
    case EMeetingRoomStatus.Completed:
      return "MeetingStatus.Completed";
    default:
      return "MeetingStatus.Unknown";
  }
};

export enum EDocumentStatus {
  PendingRelease = 0,
  Released = 1,
  Revocation = 2
}

export const documentStatusTitle = (status?: EDocumentStatus | null) => {
  switch (status) {
    case EDocumentStatus.PendingRelease:
      return "Docs.Status.PendingRelease";
    case EDocumentStatus.Released:
      return "Docs.Status.Released";
    case EDocumentStatus.Revocation:
      return "Docs.Status.Revocation";
    default:
      return "Docs.Status.Unknown";
  }
};

export const documentStatusColor = (
  status?: EDocumentStatus | null
): { color: string; bgcolor: string } => {
  switch (status) {
    case EDocumentStatus.PendingRelease:
      return { color: "#3091F3", bgcolor: "#EAF4FE" };
    case EDocumentStatus.Released:
      return { color: "#54BD95", bgcolor: "#EEF8F4" };
    case EDocumentStatus.Revocation:
      return { color: "#ED3E47", bgcolor: "#FFEFF0" };
    default:
      return { color: "#AAAAB2", bgcolor: "#F0F0F0" };
  }
};

export enum EStageColumnColor {
  Purple50 = "#F3E5F5",
  // DeepPurple50 = "#EDE7F6",
  // Indigo50 = "#E8EAF6",
  Blue50 = "#E3F2FD", //
  // LightBlue50 = "#E1F5FE",
  Cyan50 = "#E0F7FA", //
  Teal50 = "#E0F2F1", //
  // Green50 = "#E8F5E9",
  LightGreen50 = "#F1F8E9", //
  Lime50 = "#F9FBE7", //
  // Orange50 = "#FFF3E0",
  // DeepOrange50 = "#FBE9E7",
  Brown50 = "#EFEBE9",
  BlueGray50 = "#ECEFF1"
}

export const eFireBaseComponent = (
  status?: EFireBaseType | null
): { icon: string; text: string } => {
  switch (status) {
    case EFireBaseType.AssignTask:
    case EFireBaseType.UpdateTask:
    case EFireBaseType.CommentTask:
    case EFireBaseType.ReplyCommentTask:
      return { icon: Work, text: "Work" };

    case EFireBaseType.RegisterTimeOff:
    case EFireBaseType.AprroveTimeOff:
      return { icon: TimeOff, text: "TimeOff" };

    case EFireBaseType.RegisterMeetingRoomSchedule:
    case EFireBaseType.AwaitCancelMeetingRoomSchedule:
    case EFireBaseType.AprroveMeetingRoomSchedule:
    case EFireBaseType.CancelMeetingRoomSchedule:
      return { icon: Meeting, text: "Meeting" };

    case EFireBaseType.ReleasedDocument:
      return { icon: Office, text: "Office" };

    default:
      return { icon: "", text: "" };
  }
};

export enum EAlphabetColor {
  A = "#FFCDD2", //*
  B = "#F8BBD0",
  C = "#E1BEE7",
  D = "#D1C4E9", //*
  E = "#C5CAE9",
  F = "#BBDEFB",
  G = "#B3E5FC", //*
  H = "#B2EBF2",
  I = "#B2DFDB",
  J = "#C8E6C9", //*
  K = "#DCEDC8",
  L = "#F0F4C3",
  M = "#FFF9C4", //*
  N = "#FFECB3",
  O = "#FFE0B2",
  P = "#FFCCBC", //*
  Q = "#D7CCC8",
  R = "#CFD8DC",
  S = "#80D8FF", //*
  T = "#84FFFF",
  U = "#A7FFEB",
  V = "#B9F6CA", //*
  W = "#CCFF90",
  X = "#F4FF81",
  Y = "#FF9E80", //
  Z = "#FF8A80"
}

export const enumFromValue = <T extends Record<string, string>>(
  val: any,
  _enum: T
) => {
  // const enumName = (Object.keys(_enum) as Array<keyof T>).find(
  //   k => _enum[k] === val
  // );
  // if (!enumName) throw Error(); // here fail fast as an example
  // return _enum[enumName];
  let name;
  if (val in _enum) {
    return _enum[val];
  }
};

// export const getEAlphabet = (
//   value?: string | null
// ): { color: string; bgcolor: string } => {
//   switch (value) {
//     case "A":
//       return ;
//     case EDocumentStatus.Released:
//       return { color: "#54BD95", bgcolor: "#EEF8F4" };
//     case EDocumentStatus.Revocation:
//       return { color: "#ED3E47", bgcolor: "#FFEFF0" };
//     default:
//       return { color: "#AAAAB2", bgcolor: "#F0F0F0" };
//   }
// };
